import React from 'react'
import PropTypes from 'prop-types'
import SpinningIcon from '@pcln/spinning-icon'
import styled from 'styled-components'
import { Flights, ArrowRight } from 'pcln-icons'

import { format, parse } from 'date-fns'
import { Flex, Text, Hide } from 'pcln-design-system'

import { ArrowRoundTrip } from '../Icons'
import airTheme from '../AirThemeProvider/airTheme'

const BlueText = (props) => (
  // eslint-disable-next-line react/prop-types
  <Text {...props} color={'primary.base'} fontSize={props.fontSize || 2} />
)

const FlexWrapper = styled(Flex)`
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-align: center !important;

  ${airTheme.flyQueries.tablet} {
    flex-direction: row;
    text-align: left !important;
  }
`

const AlignedBlueText = styled(BlueText)`
  line-height: 24px;
  text-align: center;

  ${airTheme.flyQueries.tablet} {
    text-align: left;
  }
`

const AlignedFlex = styled(Flex)`
  justify-content: center;

  ${airTheme.flyQueries.tablet} {
    justify-content: left;
  }
`

const Title = styled(AlignedBlueText)`
  max-width: 200px;
`

export default function Loader({
  ctaTitle,
  tripType,
  destination,
  returnDate,
  departDate,
  passengerCount,
  origin,
}) {
  const inputDateFormat = 'yyyy-MM-dd'
  const displayDateFormat = 'EEE, MMM d'
  const departStr = format(parse(departDate, inputDateFormat, new Date()), displayDateFormat)
  const returnStr = returnDate && format(parse(returnDate, inputDateFormat, new Date()), displayDateFormat)
  return (
    <FlexWrapper justify='center' pl={2} pr={2}>
      <Flex align='center' flexWrap={'wrap'} mb={3}>
        <Hide md lg xl xxl>
          <SpinningIcon iconNode={<Flights size={52} />} />
        </Hide>
        <Hide xs sm>
          <SpinningIcon iconNode={<Flights size={78} />} />
        </Hide>
      </Flex>

      <Flex justify='center' flexDirection='column' ml={3}>
        <Title bold fontSize={'16px'} mb={2}>
          {ctaTitle}
        </Title>

        {/* Origin & Destination */}
        <AlignedFlex flexWrap={'nowrap'} alignItems={'center'}>
          <AlignedBlueText fontSize={3} bold>
            {origin}
          </AlignedBlueText>
          {tripType === 'OW' ? (
            <ArrowRight color='primary.base' size={18} />
          ) : (
            <ArrowRoundTrip color='primary.base' size={18} />
          )}
          <AlignedBlueText fontSize={3} bold>
            {destination}
          </AlignedBlueText>
        </AlignedFlex>

        {/* Depart & Return Dates */}
        <AlignedFlex>
          <AlignedBlueText>{departStr}</AlignedBlueText>
          {returnDate && <AlignedBlueText>&nbsp;&ndash; {returnStr}</AlignedBlueText>}
        </AlignedFlex>

        {/*  Passenger Count */}
        <AlignedBlueText>
          {passengerCount} passenger{passengerCount > 1 ? 's' : ''}
        </AlignedBlueText>
      </Flex>
    </FlexWrapper>
  )
}

Loader.propTypes = {
  ctaTitle: PropTypes.string,
  origin: PropTypes.string.isRequired,
  destination: PropTypes.string.isRequired,
  departDate: PropTypes.string.isRequired,
  returnDate: PropTypes.string.isRequired,
  passengerCount: PropTypes.number.isRequired,
  tripType: PropTypes.string.isRequired,
}
